import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_NOTE_TYPES](state, data) {
    console.log('mutation ', data)
    state.allNoteTypes = data
  },
}
